import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store';
import { fetchStaticContent } from 'store/staticContent/action';

function useStaticContent(byItem?: string) {
  const { data: staticContent, loading } = useSelector(
    (state: RootState) => state.staticContent
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!staticContent && !loading) {
      dispatch(fetchStaticContent());
    }
  }, [staticContent, loading, dispatch]);

  if (loading) return;

  return byItem ? staticContent[byItem] : staticContent;
}

export default useStaticContent;
